import {Title} from "@mantine/core";

export function Overview() {
    return (
        <Title order={1} size="h6" style={{color: "light-dark(#004852, #3FA0C0)"}} fw={600} id="overview">
            OVERVIEW
        </Title>
    );
}